import * as React from 'react';

export type CountDisplayProps = {
    /**
     * The current (active) page number.
     */
    currentPage: number;
    /**
     * The size of each page.
     */
    pageSize: number;
    /**
     * The total number of results.
     */
    total: number;
    /**
     * Class name to apply to the text.
     */
    className?: string;
    /**
     * Styles to apply to the text.
     */
    style?: React.CSSProperties;
};

/**
 * Shows the range of items currently displayed in a set of paged results,
 * for example, "16-32 of 793".
 */
export function CountDisplay({
    currentPage,
    pageSize,
    total,
    className,
    style,
}: CountDisplayProps) {
    // The item number of the first item in the current page
    const firstItemNumber = (currentPage - 1) * pageSize + 1;
    // The item number of the last item in the current page
    const lastItemNumber = Math.min(total, firstItemNumber + pageSize - 1);

    return (
        <span className={className} style={style}>
            {firstItemNumber}-{lastItemNumber} of {total}
        </span>
    );
}
